import React from 'react'

const SvgIconFilters = (props) => (
  <svg viewBox="0 0 14 11" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.334 2.667a.667.667 0 0 1-.667.666H1A.667.667 0 1 1 1 2h4.667c.368 0 .667.298.667.667zM13.667 2.667a.667.667 0 0 1-.667.666H8.334a.667.667 0 0 1 0-1.333H13c.368 0 .667.298.667.667zM7.667 8A.667.667 0 0 1 7 8.666H1a.667.667 0 1 1 0-1.333h6c.369 0 .667.299.667.667zM13.667 8a.667.667 0 0 1-.667.666H9.667a.667.667 0 1 1 0-1.333H13c.368 0 .667.299.667.667z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.667 0c.368 0 .667.298.667.667v4a.667.667 0 0 1-1.334 0v-4C5 .298 5.3 0 5.667 0zM9.667 5.333c.368 0 .667.299.667.667v4A.667.667 0 0 1 9 10V6c0-.368.299-.667.667-.667z"
      fill="currentColor"
    />
  </svg>
)

export default SvgIconFilters
